import { DEFAULT_THEME, THEME_NAMES, type ThemeName } from './types.js';

export const THEME_STORAGE_KEY = 'chefcook:theme';

function isValidTheme(value: string | null): value is ThemeName {
  return typeof value === 'string' && (THEME_NAMES as readonly string[]).includes(value);
}

/**
 * Reads the saved theme from localStorage and applies it to <html data-theme>.
 * Must be called before any stylesheet evaluates so the correct palette is
 * rendered on first paint (no FOUC). Mirrors the inline bootstrap script in
 * frontend/index.html.
 */
export function applyStoredTheme(doc: Document = document): ThemeName {
  let theme: ThemeName = DEFAULT_THEME;
  try {
    const stored = doc.defaultView?.localStorage.getItem(THEME_STORAGE_KEY) ?? null;
    if (isValidTheme(stored)) theme = stored;
  } catch {
    /* ignore */
  }
  doc.documentElement.setAttribute('data-theme', theme);
  return theme;
}
